import styled from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import {
  FONT_STACK,
  FontWeight,
  FontSize,
  STANDARD_TRANSITION,
  STANDARD_SHRINK,
} from '../../../styles/constants';
import { HIDE_SCROLL_BAR } from '../../../styles/mixins';
import { IconDropDown } from '../../icons/IconDropDown/IconDropDown';

export const StyledButton = styled.button`
  ${FONT_STACK};
  ${STANDARD_TRANSITION};
  ${HIDE_SCROLL_BAR};
  align-items: center;
  background-color: ${ThemeColours.white};
  border: 1px solid ${ThemeColours.mono300};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex: 0 0 auto;
  font-size: ${FontSize.REGULAR};
  font-weight: ${FontWeight.REGULAR};
  height: 48px;
  justify-content: center;
  margin: 0 8px;
  padding: 0 16px;

  &:active {
    transform: scale(${STANDARD_SHRINK});
  }
`;

export const DropDownIcon = styled(IconDropDown)`
  height: 24px;
  margin-inline-start: 1px;
  width: 24px;
`;

export const Wrapper = styled.div`
  display: inline-block;
  position: relative;
`;
